import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/admin?page=1&maxData=99999999&branchId=' // (1) 직원 목록 조회

const fetchKey = (branchId, teamId, createdAt, updatedAt, searchWord, page, pageSize) =>
	`/admin?page=${page}&maxData=${pageSize}&branchId=${branchId}&teamId=${teamId}&createdAt=${createdAt}&updatedAt=${updatedAt}&searchWord=${searchWord}`;

let swrData: any = getPersistData(KEY)

export function useEmployeeList(branchId, teamId, createdAt, updatedAt, searchWord, page = 1, pageSize = 10) {
	const { data: token } = useToken()
	const url = fetchKey(branchId, teamId, createdAt, updatedAt, searchWord, page, pageSize);

	const { data, mutate } = useSWR<any>(
		url,
		async () => {
			const response = await API.get(url, token + '', {})
			return {
				list: response.result?.result?.list,
				total: response.result?.result?.totalCount
			};
		},
		{ revalidateOnFocus: true }
	)

	return {
		employeeList: data?.list,
		total: data?.total,
		mutate,
	}
}